function r(r){if(r.response){const o=r.response.data;null!=o&&o.errors&&(r.errors=o.errors)}throw r}export{r as error};
